<template>
  <div id="mainContent" class="clearfix row">
    <div class="textCenter" style="min-height: 40px; position: relative">
      <Headerv2 title="Invite your Partner" />
      <!-- <div class="text-xl pt-4 text-black">Invite your Partner</div> -->
    </div>
    <div id="flexDiv row" class="clearfix" style="min-height: 500px">
      <div class="col-xs-12">
        <p class="alert-mira mt-3 mb-3">
          Send your partner a link to create a HomeRun Account and connect it to
          your own.
        </p>
        <div>
          <div class="relative">
            <DropdownSelection data-cy="school-dropdown-picker" keyProp="id" v-if="schools.length > 0 && school_id"
              single small class="smallDropdown mb-4" name="name" default_label="Select School" :blueTheme="true"
              :items="schools" :default_value="school_id" @updated="changeSchool" />
          </div>
          <span class="text-left float-left font-medium text-sm">Select Children</span><br />
          <div>
            <div name="fade" tag="div" v-if="sortedChildren.length > 0 && school_id">
              <div :key="student.id" v-for="student in sortedChildren" class="studentContainer"
                :class="{ disabled: isChildDisabled(student) }" data-cy="child-container">
                <img class="smallAvatar" :class="{ selected: student.selected }" @click="toggleChild(student)"
                  :src="child_avatars_url + student.profile_photo" />
                <span v-if="isChildDisabled(student)" class="circleWrapper"
                  :class="{ pendingInvite: student.pendingInvite }">
                  <span v-if="student.pendingInvite" class="fas fa-clock"></span>
                  <span v-if="!student.pendingInvite" class="fal fa-check"></span>
                </span>
                <span class="text-xs" :title="student.first_name">
                  {{ student.first_name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <van-field id="text_input" name="Email" data-cy="email_input" placeholder="Partner's email" type="text"
          v-model="email" maxlength="50" class="roundInput !border-gray-400 mb-2" />
      </div>
      <div class="">
        <div class="col-xs-12 flowBottomButtonDiv" style="flex-grow: 0">
          <van-button type="info" data-cy="go_back_btn" class="greyBtn" @click="$router.go(-1)" plain>
            Go Back
          </van-button>
          <van-button type="info" name="button" data-cy="submit" class="blackBtn" @click="sendInvitation()"
            :disabled="!isEmailValid || selectedChildrenIds.length === 0">
            Invite
          </van-button>
        </div>
      </div>
      <div>
        <div :key="invitation.id" v-for="invitation in invitations">
          <van-button name="button" :data-cy="'revoke_' + (invitation.email || '').replace(/[@.+]/g, '_')"
            class="!bg-red-500 !text-white" :loading="loading" @click="cancelInvitation(invitation.id)">
            ({{ invitation.email }}) - Revoke <i class="fas fa-times"></i>
          </van-button>
        </div>
      </div>
      <!-- <div id="bottomLogo" class="text-center">
        <img
          src="@/assets/wireframe_logo.svg"
          style="vertical-align: baseline"
        />
      </div> -->
      <modal name="miEmailNotFoundModal" :adaptive="true" :height="'auto'" :scrollable="true"
        data-cy="email_already_exists_modal">
        <div class="">
          <div class="col-xs-12" style="margin-bottom: 50px; margin-top: 50px; text-align: center">
            <MiFlowHeader page_title="Sorry, we couldn't find that email." :logo="null" />
            <p class="mialert lightRed">
              We couldn't find this email on your school's system. Please check
              that you have typed the email correctly, or contact your school if
              you believe there is an error
            </p>
          </div>
        </div>
        <div class="col-xs-12">
          <van-button type="info" data-cy="email_already_exists_modal_close_btn"
            @click="hideModal('miEmailNotFoundModal')" class="greyBtn" plain>
            Go Back
          </van-button>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import ApiService from "@/services/ApiService";
import MiFlowHeader from "@/components/registration_mi/MiFlowHeader.vue";
import Headerv2 from "@/components/Headerv2.vue";
import DropdownSelection from "@/components/DropdownSelection";

export default {
  name: "invitePartner",
  components: {
    MiFlowHeader,
    Headerv2,
    DropdownSelection,
  },
  data() {
    return {
      email: "",
      child_avatars_url: "https://s3-eu-west-1.amazonaws.com/home-run/",
      children: [],
      schools: [],
      invitations: [],
      loading: false,
      school_id: null,
    };
  },
  computed: {
    sortedChildren() {
      return this.children
        .filter(child => child.organization_id === this.school_id)
        .sort((a, b) => {
          // First sort by disabled state (enabled first)
          if (a.disabled !== b.disabled) {
            return a.disabled - b.disabled;
          }
          // Then sort by pending invite status (non-pending first)
          if (a.pendingInvite !== b.pendingInvite) {
            return (a.pendingInvite ? 1 : 0) - (b.pendingInvite ? 1 : 0);
          }
          return 0;
        });
    },
    isEmailValid() {
      return this.email && this.email.includes('@') && this.email.includes('.');
    },
    selectedChildrenIds() {
      return this.children
        .filter(child => child.selected)
        .map(child => child.id);
    },
  },
  methods: {
    isChildDisabled(child) {
      return child.parents.length > 1 || child.pendingInvite;
    },

    toggleChild(child) {
      if (this.isChildDisabled(child)) {
        if (child.parents.length > 1) {
          this.$notify({
            message: `You've already invited a partner for ${child.first_name}`,
            type: "warning",
          });
        } else if (child.pendingInvite) {
          this.$notify({
            message: "You already have a pending invite",
            type: "warning",
          });
        }
        return;
      }

      child.selected = !child.selected;
    },
    async getInvitations() {
      try {
        const response = await ApiService.userApi.allInvitations();
        this.$store.dispatch("loading", false);
        this.invitations = response.data.invitations;

        // Extract pending student IDs from invitations
        const pendingStudentIds = this.invitations.flatMap(invitation => {
          const children = JSON.parse(invitation.children);
          return children;
        });

        // Update children state based on pending invites and parent count
        this.children = this.children.map(child => {
          const hasMultipleParents = child.parents.length > 1;
          const hasPendingInvite = pendingStudentIds.includes(child.id);

          return {
            ...child,
            disabled: hasMultipleParents || hasPendingInvite,
            pendingInvite: hasPendingInvite
          };
        });

        // Filter schools to only show those with children
        const schoolsWithChildren = [...new Set(this.children.map(child => child.organization_id))];
        this.schools = this.schools.filter(school =>
          schoolsWithChildren.includes(school.id)
        );

        if (this.schools.length > 0) {
          this.changeSchool([this.schools[0].id]);
        }
      } catch (error) {
        this.$store.dispatch("loading", false);
        console.error('Error fetching invitations:', error);
      }
    },
    async getUserSchools() {
      this.$store.dispatch("loading", true);
      try {
        const response = await ApiService.userApi.getUserSchools();
        this.schools = response.data.schools;
        this.children = response.data.children.map(child => ({
          ...child,
          selected: false,
          disabled: false,
          pendingInvite: false
        }));

        if (this.schools.length > 0) {
          this.school_id = this.schools[0].id;
        }

        await this.getInvitations();

        // Select children from first school by default if they can be toggled
        this.selectDefaultChildren();
      } catch (error) {
        this.$store.dispatch("loading", false);
        console.error('Error fetching user schools:', error);
      }
    },
    async sendInvitation() {
      const selectedChildrenIds = this.selectedChildrenIds;

      if (selectedChildrenIds.length === 0) {
        this.$notify({
          message: "Please select a child/children to continue",
          type: "warning",
        });
        return;
      }

      const payload = {
        email: this.email,
        childrenIds: selectedChildrenIds,
      };

      try {
        const response = await ApiService.userApi.createInvitation(payload, selectedChildrenIds);
        if (response.status === 200) {
          this.$notify({
            message: "Invitation sent successfully.",
            type: "success",
          });

          // Clear selections
          this.children.forEach(child => {
            child.selected = false;
          });

          await this.getInvitations();
        }
      } catch (error) {
        this.$modal.show("miEmailNotFoundModal");
      }
    },
    async cancelInvitation(id) {
      try {
        await ApiService.userApi.cancelInvitation(id);
        this.$notify({
          message: "Removed",
          type: "success",
        });
        await this.getInvitations();
      } catch (error) {
        console.error('Error canceling invitation:', error);
      }
    },

    hideModal() {
      this.$modal.hide("miEmailNotFoundModal");
    },

    selectDefaultChildren() {
      if (this.school_id) {
        this.children.forEach(child => {
          if (child.organization_id === this.school_id && !this.isChildDisabled(child)) {
            child.selected = true;
          }
        });
      }
    },

    changeSchool(id) {
      if (id === "all" || this.school_id === id[0]) {
        return;
      }

      this.school_id = id[0];

      // Update child selections based on new school
      this.children.forEach(child => {
        child.selected = child.organization_id === this.school_id && !this.isChildDisabled(child);
      });
    },
  },
  mounted() {
    this.getUserSchools();
  },
};
</script>
<style scoped>
img.smallAvatar {
  margin: 5px;
  margin-bottom: 0px;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 35px;
  padding: 1px;
}

img.smallAvatar.selected {
  padding: 2px;
  border: 2px solid #2fab69;
}

.smallAvatar {
  width: 70px;
  height: 70px;
}

.studentContainer.disabled img {
  cursor: default;
  opacity: 0.3;
}

.studentContainer {
  display: inline-block;
  margin-bottom: 5px;
  overflow: hidden;
  max-width: 75px;
  position: relative;
}

.studentContainer span {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60px;
  overflow: hidden;
  display: inline-block;
}

span.circleWrapper {
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 15px;
  padding-top: 4px;
  top: 55px;
  right: 5px;
  background: #009900;
}

span.circleWrapper.pendingInvite {
  background: #ff9900;
}

span.circleWrapper span {
  color: white;
}
</style>
